export const dealershipTrack = 'dealership';

export const evProject = 'ev-landing';

export const evTrack = 'ev-landing';

export const financingTrack = 'financing';

export const guideToBuyingEvProject = 'guide-to-buying-ev-landing';

export const guideToBuyingEvTrack = 'guide-to-buying-ev-landing';

export const homeProject = 'home';

export const homeTrack = 'home';

export const newCarsProject = 'new-car-configurator';

export const newCarsTrack = 'new-car-configurator';

export const notFoundProject = 'not-found';

export const notFoundTrack = 'not-found';

export const searchProject = 'search';

export const searchTrack = 'search';

export const serviceProject = 'service';

export const shaqvanaProject = 'shaqvana';

export const shaqvanaTrack = 'shaqvana';

export const shareProject = 'share-your-carvana';

export const shareTrack = 'share-your-carvana';

export const sitePageProject = 'site-page';

export const sitePageTrack = 'site-page';

export const vdpLitePage = 'vdp-lite';

export const vdpStandardPage = 'vdp';

export const vdpTrack = 'vdp';

export const vendingMachinePage = 'vending-machine';

export const vendingMachineTrack = 'vending-machine';

export const whatToExpectProject = 'what-to-expect';

export const whatToExpectTrack = 'what-to-expect';
